export class SentryError extends Error {
  constructor(message) {
    super(message);
    this.name = message;
  }
}
